import React, {useEffect, useRef} from 'react';
import MaterialTable from 'material-table';
import { forwardRef } from 'react';
import AddBox from '@material-ui/icons/AddBox';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';
import { NavLink } from 'react-router-dom';
import Cookies from 'js-cookie';
import { TablePagination } from '@material-ui/core';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CircularProgress from '@material-ui/core/CircularProgress';
import TextField from '@material-ui/core/TextField';
import SearchIcon from '@material-ui/icons/Search';
import InputAdornment from '@material-ui/core/InputAdornment';
import API_PATH from "../../constants/config.json";
import TableIcons from '../TableIcons';
const axios = require('axios');
const API_URL = process.env.REACT_APP_BASE_URL;

const Groups = (props) =>{

    const [teamList, setTeamList] = React.useState([]);
    const [pagination, setPagnation] = React.useState({ selectedPage: 1 });
    const [totalItems, setTotalItems] = React.useState(0);
    const [userAccess, setUserAccess] = React.useState(true);
    const [getLoader, setLoaderDisable] = React.useState(false);
    const [getSearchTerm, setSearchTerm] = React.useState("");
    const [hover, setHower] = React.useState(false);
    const [errSearchValue, setErrSearchValue] = React.useState(null);
    const refContainer = useRef('');
    const tableRef = useRef();
    const enteriesPerPage = 10;
    let values = {
        "pageNo": pagination.selectedPage,
        "entriesPerPage": enteriesPerPage,
    }
    let pages = teamList.length > 10 ? true : false;

    useEffect(
        () => {
            if(props.needToReload) {
                getGroupsAPI();
            }
        }, [props.needToReload]
    )

    const getGroupsAPI = (search = "", enable = false) => {
        setLoaderDisable(true);
        try {
            axios({
            method: 'post',
            data: {
                pageNo: pagination.selectedPage,
                entriesPerPage: enteriesPerPage,
                searchEnable: enable,
                searchValue: search
            },
            headers: {
                'payload': Cookies.get('payload'),
                'agencyid': sessionStorage.getItem('agency_id')
            },
            url: API_URL + API_PATH.getTeamList,
            })
            .then(async function (response) {
                if (response.status && response.status == '200') {
                setLoaderDisable(false);
                setTeamList(response.data.result.rows);
                setTotalItems(response.data.result.count);
                } else {
                setLoaderDisable(false);
                setTeamList([]);
                setTotalItems(0)
                }

            })
            .catch(function (error) {
                if (error.response) {
                if (error.response.data.status == 403) {
                    setLoaderDisable(false);
                    setUserAccess(false);
                    setTeamList([]);
                    setTotalItems(0)
                } else {
                    setLoaderDisable(false);
                    setTeamList([]);
                    setTotalItems(0)
                }
                } else {
                setLoaderDisable(false);
                setTeamList([]);
                setTotalItems(0)
                }
            })
        } catch (error) {
            console.error(error);
        }
    }

    const handleSelected = (e, selectedPage) => {
        values.pageNo = selectedPage + 1
        setPagnation({ selectedPage: selectedPage + 1 })
        getGroupsAPI();
    }

    const kekPressSearch = (e) => {    
        if(e.key === 'Enter'){
          e.preventDefault();
          onSearch();
        }    
    }
    
    const searchField = (e) => {
        setErrSearchValue(null); 
        setHower(true)    
        setSearchTerm(e.target.value);   
        getGroupsAPI(e.target.value, true)
        setPagnation({ selectedPage: 1 })    
    }
    
    const onSearch = () => {   
        setErrSearchValue(null);    
        if(getSearchTerm == ''){      
          setErrSearchValue("Please enter a search term.");
          return;
        }
        getGroupsAPI(getSearchTerm, true)
        setPagnation({ selectedPage: 1 })
    }
    
    const clearText = () => {
        refContainer.current.reset();
        setErrSearchValue(null); 
        setSearchTerm('');
        getGroupsAPI();
    }

    return(
        <React.Fragment>  
            <div className="table-top">
                <h3>Groups</h3>
                <form ref={refContainer} noValidate autoComplete="off">
                    <TextField
                    id="input-with-icon-textfield"
                    placeholder="Search"
                    onChange={(e) => searchField(e)}
                    onKeyPress={(e) => kekPressSearch(e)}
                    InputProps={{
                        startAdornment: (
                        <InputAdornment position="start" onClick={onSearch}>
                            <SearchIcon style={{ cursor: 'pointer' }} />
                        </InputAdornment>
                        ),
                        endAdornment: (
                        <InputAdornment position="end">
                            {hover && <FontAwesomeIcon icon={faTimes} onClick={clearText} />}
                        </InputAdornment>
                        ),
                    }}

                    />      
                    
                </form>
            </div>   
            <div className={props.scrolled ? "table-container scrolled-el" : "table-container"} onScroll={() => props.handleScroll(tableRef)} ref={tableRef}>
                <MaterialTable
                    icons={TableIcons}
                    title=""
                    columns={[
                        {
                        title: 'Name', field: 'team_name', width: '25%', 
                        render: rowData => <NavLink to="#" onClick={() => { props.handleGroupTabs(rowData.teams_id) }}>{rowData.team_name}</NavLink>
                        },
                        {
                        title: '# of users', field: 'total_user', type: 'numeric', width: '12%', cellStyle: { textAlign: 'left' }, headers: { textAlign: 'left' },
                        },
                        { title: 'Description', field: 'description' },
            
                    ]}
                    data={teamList ? teamList : []}
                    totalCount={totalItems}
                    options={{
                        filtering: false,
                        sorting: false,
                        paging: pages,
                        pageSize: 10,
                        pageSizeOptions: [10, 20],
                        search: false,
                        draggable: false
                    }}
                    components={
                        userAccess == true ?
                        getLoader == false?
                        {
                            Pagination: props => (
                                <TablePagination
                                {...props}
                                count={totalItems}
                                page={pagination.selectedPage - 1}
                                onChangePage={handleSelected}
                                rowsPerPage={enteriesPerPage}
                                />
                            ),
                            }
                            :
                            {
                                Pagination: props => (
                                <TablePagination
                                    {...props}
                                    count={totalItems}
                                    page={pagination.selectedPage - 1}
                                    onChangePage={handleSelected}
                                    rowsPerPage={enteriesPerPage}
                                />
                                ),
                                Body: (props) => (
                                <tbody><tr style={{ height: '49px' }}><td colspan="3" style={{ width: '100%', paddingTop: '0px', paddingBottom: '0px', textAlign: 'center' }}><span style={{ color: '#CC0000', fontWeight: '600' }}><CircularProgress/></span> </td></tr></tbody>
                                )
                            }
                        : {
                            Pagination: props => (
                                <TablePagination
                                {...props}
                                count={totalItems}
                                page={pagination.selectedPage - 1}
                                onChangePage={handleSelected}
                                rowsPerPage={enteriesPerPage}
                                />
                            ),
                            Body: (props) => (
                                <tbody><tr style={{ height: '49px' }}><td colspan="3" style={{ paddingTop: '0px', paddingBottom: '0px', textAlign: 'center' }}><span style={{ color: '#CC0000', fontWeight: '600' }}><FontAwesomeIcon icon={faTimes} /> Access Forbidden</span> </td></tr></tbody>
                            )
                        }
                    }
                />  
            </div>
        </React.Fragment>
    );
}
export default Groups;